import {
    IGridParams,
    IStoredGridState,
    IUrlGrid,
} from '@pages/generics/grid/state-handlers/handler-types';
import { IDropdownOption } from '@uipath/angular/components/ui-grid';
import { ISuggestValue } from '@uipath/angular/components/ui-suggest';

import pickBy from 'lodash-es/pickBy';

export class StorageAdapter<TEntity> {
    constructor(private _grid: IUrlGrid<TEntity>) { }

    public isStateStored() {
        return this._grid.storageService.contains(this._grid.storageKey);
    }

    public getState(): IStoredGridState | null {
        return this._grid.storageService.get(this._grid.storageKey);
    }

    public storeState(params: IGridParams) {
        const isDropdownOption = (f: IDropdownOption | ISuggestValue) => !!(f as IDropdownOption).label;

        this._grid.storageService.set(
            this._grid.storageKey,
            {
                filters: params.filters && pickBy(params.filters, isDropdownOption),
                size: params.size,
                sort: params.sort,
            },
        );
    }
}
